// @flow
import { authenticatedFetch } from '../../../api/request';
import { deserializeNotifications } from './notificationsTransformer';

export default async function getNotifications() {
    const url = `/v5/notifications`;
    const response = await authenticatedFetch(url);
    return deserializeNotifications(response);
}



// WEBPACK FOOTER //
// ./src/v5/notifications/api/getNotifications.js